import React from 'react'

const StudentPortalRoute = ({children}) => {
  return children
}

export default StudentPortalRoute